import React from "react";
interface IconProps {
    fill: string;
    class?: string;
    className?: string;
    height: number;
}


export const LightningIcon = (props: IconProps) => (
    <svg fill={props.fill} className={props.class} viewBox="0 0 959.63 959.631" width={props.height} height={props.height} >
        <g>
        <path d="M364.997,938c-1.601,20.699,25.5,29.9,36.8,12.4l322-500.701c8.6-13.3-1-30.8-16.8-30.8h-119.8
		c-14.7,0-24.4-15.399-18-28.7L742.597,28.7c6.4-13.3-3.3-28.7-18-28.7H325.896c-9.8,0-18.199,7.1-19.699,16.8l-90.9,564.6
		c-2,12.199,7.4,23.199,19.7,23.199h134.7c11.699,0,20.899,9.9,19.899,21.6L364.997,938z"/>

        </g>

    </svg>
)


// WEBPACK FOOTER //
// ./src/layout/icons/Lightning.tsx